import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/app/globals.css";
import App from "./App";
import { navigate } from "./router";
import { coldStartRedirect } from "@/lib/launch-preference";

// "Open by default": a Home Screen launch of the shell at "/" goes straight
// into the chosen app (client route switch — no network, no launcher flash).
// Reloads, "All apps" and app-switching never trigger it (see the module).
{
  const target = coldStartRedirect(window.location.pathname);
  if (target) navigate(target, { replace: true });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The Next build auto-registered the SW via @serwist/next; the SPA registers
// it explicitly. Dev serves no sw.js — guard on availability, never on env,
// so preview builds behave exactly like prod.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
